var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFutersImg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 130,
    viewBox: "0 0 184 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.76 69.78H40.48L20.48 8.77002H132.76L112.76 69.78Z",
    fill: "#2E025A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.76 63.01H40.48L20.48 2H132.76L112.76 63.01Z",
    fill: "url(#paint0_linear_222_99)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.76 49.2803C61.76 47.8958 61.3495 46.5425 60.5803 45.3913C59.8111 44.2402 58.7179 43.3429 57.4388 42.8131C56.1597 42.2833 54.7523 42.1447 53.3944 42.4148C52.0365 42.6849 50.7892 43.3516 49.8103 44.3305C48.8313 45.3095 48.1646 46.5568 47.8945 47.9147C47.6244 49.2725 47.763 50.68 48.2929 51.9591C48.8227 53.2381 49.7199 54.3314 50.871 55.1006C52.0222 55.8697 53.3755 56.2803 54.76 56.2803C56.6165 56.2803 58.397 55.5428 59.7098 54.23C61.0225 52.9173 61.76 51.1368 61.76 49.2803Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6299 49.2803C83.6299 47.8958 83.2193 46.5425 82.4502 45.3913C81.681 44.2402 80.5878 43.3429 79.3087 42.8131C78.0296 42.2833 76.6221 42.1447 75.2643 42.4148C73.9064 42.6849 72.6591 43.3516 71.6801 44.3305C70.7012 45.3095 70.0345 46.5568 69.7644 47.9147C69.4943 49.2725 69.6329 50.68 70.1627 51.9591C70.6925 53.2381 71.5897 54.3314 72.7409 55.1006C73.892 55.8697 75.2454 56.2803 76.6299 56.2803C78.4864 56.2803 80.2669 55.5428 81.5796 54.23C82.8924 52.9173 83.6299 51.1368 83.6299 49.2803Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 49.2803C105.5 47.8958 105.089 46.5425 104.32 45.3913C103.551 44.2402 102.458 43.3429 101.179 42.8131C99.8997 42.2833 98.4922 42.1447 97.1344 42.4148C95.7765 42.6849 94.5292 43.3516 93.5503 44.3305C92.5713 45.3095 91.9046 46.5568 91.6345 47.9147C91.3644 49.2725 91.503 50.68 92.0329 51.9591C92.5627 53.2381 93.4599 54.3314 94.611 55.1006C95.7622 55.8697 97.1155 56.2803 98.5 56.2803C100.357 56.2803 102.137 55.5428 103.45 54.23C104.763 52.9173 105.5 51.1368 105.5 49.2803Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 31.3003H47.74C47.2096 31.3003 46.7008 31.0896 46.3258 30.7145C45.9507 30.3394 45.74 29.8307 45.74 29.3003C45.74 28.7699 45.9507 28.2612 46.3258 27.8861C46.7008 27.511 47.2096 27.3003 47.74 27.3003H105.5C106.03 27.3003 106.539 27.511 106.914 27.8861C107.289 28.2612 107.5 28.7699 107.5 29.3003C107.5 29.8307 107.289 30.3394 106.914 30.7145C106.539 31.0896 106.03 31.3003 105.5 31.3003Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_222_99)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_222_99",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 176,
    height: 122
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.38 2.91016H153.47L141 29.7701H4L26.71 81.9202C22.7887 83.8152 19.5276 86.8453 17.3501 90.6171C15.1727 94.3889 14.1794 98.7283 14.4993 103.072C14.8192 107.415 16.4375 111.562 19.1441 114.974C21.8506 118.386 25.5204 120.906 29.6771 122.206C33.8338 123.506 38.2853 123.527 42.4537 122.265C46.6221 121.003 50.3149 118.517 53.0527 115.13C55.7904 111.743 57.4467 107.611 57.8064 103.27C58.1662 98.93 57.2128 94.5818 55.07 90.7902H102.17C100.029 94.5803 99.0773 98.9266 99.4377 103.265C99.7981 107.603 101.454 111.732 104.191 115.117C106.928 118.502 110.619 120.986 114.786 122.247C118.952 123.507 123.401 123.486 127.556 122.187C131.71 120.887 135.378 118.368 138.083 114.958C140.788 111.547 142.405 107.402 142.725 103.061C143.044 98.7197 142.051 94.3826 139.875 90.6128C137.699 86.8429 134.439 83.8143 130.52 81.9202L146.08 46.2302L161.08 13.0002H174.42C175.758 13.0002 177.041 12.4686 177.987 11.5225C178.933 10.5764 179.465 9.29316 179.465 7.95514C179.465 6.61712 178.933 5.33391 177.987 4.38779C177.041 3.44167 175.758 2.91016 174.42 2.91016H174.38Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_222_99)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M194.14 -26.2798H-14.7V149.05H194.14V-26.2798Z",
    fill: "url(#paint1_linear_222_99)",
    fillOpacity: 0.9
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.38 3.91016C175.453 3.91016 176.482 4.33632 177.24 5.09491C177.999 5.85349 178.425 6.88234 178.425 7.95514C178.425 9.02794 177.999 10.0568 177.24 10.8154C176.482 11.574 175.453 12.0002 174.38 12.0002H161.04C160.848 12.0006 160.659 12.0564 160.498 12.1611C160.337 12.2657 160.209 12.4147 160.13 12.5901L145.13 45.8301L129.61 81.5201C129.507 81.7569 129.499 82.0245 129.588 82.2668C129.678 82.5091 129.858 82.7074 130.09 82.8202C133.831 84.6275 136.943 87.5179 139.021 91.1161C141.098 94.7143 142.046 98.854 141.741 102.998C141.436 107.142 139.893 111.098 137.311 114.353C134.729 117.609 131.228 120.012 127.262 121.253C123.296 122.493 119.05 122.512 115.073 121.308C111.096 120.104 107.573 117.732 104.962 114.501C102.35 111.269 100.77 107.327 100.428 103.186C100.085 99.0453 100.995 94.8971 103.04 91.2802C103.125 91.1281 103.17 90.9564 103.168 90.782C103.167 90.6075 103.12 90.4365 103.032 90.2859C102.944 90.1353 102.818 90.0103 102.667 89.9233C102.516 89.8364 102.344 89.7905 102.17 89.7902H55.07C54.8938 89.7895 54.7205 89.8353 54.5677 89.9231C54.415 90.0109 54.2881 90.1376 54.2 90.2902C54.1122 90.4422 54.066 90.6146 54.066 90.7902C54.066 90.9657 54.1122 91.1381 54.2 91.2902C56.2408 94.9056 57.1478 99.0509 56.8034 103.188C56.4591 107.325 54.8792 111.264 52.2688 114.492C49.6584 117.72 46.138 120.09 42.1645 121.292C38.1909 122.495 33.9475 122.476 29.985 121.237C26.0226 119.998 22.5239 117.597 19.943 114.345C17.3621 111.093 15.8181 107.141 15.5114 103C15.2047 98.86 16.1494 94.7231 18.223 91.1264C20.2966 87.5297 23.4033 84.6393 27.14 82.8301C27.3742 82.7192 27.5562 82.5217 27.6476 82.2791C27.739 82.0366 27.7327 81.7681 27.63 81.5302L5.51 30.7701H141C141.19 30.7715 141.377 30.7186 141.538 30.6176C141.699 30.5167 141.828 30.3719 141.91 30.2002L154.1 3.91016H174.38ZM174.38 2.91016H153.47L141 29.7701H4L26.71 81.9202C22.7887 83.8152 19.5276 86.8453 17.3501 90.6171C15.1727 94.3889 14.1794 98.7283 14.4993 103.072C14.8192 107.415 16.4375 111.562 19.1441 114.974C21.8506 118.386 25.5204 120.906 29.6771 122.206C33.8338 123.506 38.2853 123.527 42.4537 122.265C46.6221 121.003 50.3149 118.517 53.0527 115.13C55.7904 111.743 57.4467 107.611 57.8064 103.27C58.1662 98.93 57.2128 94.5818 55.07 90.7902H102.17C100.029 94.5803 99.0773 98.9266 99.4377 103.265C99.7981 107.603 101.454 111.732 104.191 115.117C106.928 118.502 110.619 120.986 114.786 122.247C118.952 123.507 123.401 123.486 127.556 122.187C131.71 120.887 135.378 118.368 138.083 114.958C140.788 111.547 142.405 107.402 142.725 103.061C143.044 98.7197 142.051 94.3826 139.875 90.6128C137.699 86.8429 134.439 83.8143 130.52 81.9202L146.08 46.2302L161.08 13.0002H174.42C175.758 13.0002 177.041 12.4686 177.987 11.5225C178.933 10.5764 179.465 9.29316 179.465 7.95514C179.465 6.61712 178.933 5.33391 177.987 4.38779C177.041 3.44167 175.758 2.91016 174.42 2.91016H174.38Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3199 101.82C44.3219 100.471 43.9233 99.1505 43.1747 98.0275C42.4261 96.9044 41.3611 96.0287 40.1145 95.5113C38.8679 94.9939 37.4958 94.858 36.1719 95.1208C34.848 95.3836 33.6319 96.0334 32.6775 96.9878C31.7231 97.9422 31.0733 99.1583 30.8105 100.482C30.5477 101.806 30.6836 103.178 31.201 104.425C31.7184 105.671 32.5941 106.736 33.7172 107.485C34.8403 108.234 36.1602 108.632 37.5099 108.63C38.4042 108.63 39.2898 108.454 40.116 108.112C40.9422 107.77 41.693 107.268 42.3253 106.636C42.9577 106.003 43.4593 105.253 43.8015 104.426C44.1438 103.6 44.3199 102.715 44.3199 101.82Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.82 101.82C128.822 100.471 128.424 99.1514 127.675 98.0285C126.927 96.9057 125.863 96.03 124.617 95.5122C123.371 94.9945 121.999 94.858 120.676 95.1201C119.352 95.3821 118.136 96.0308 117.181 96.9842C116.226 97.9376 115.576 99.1528 115.312 100.476C115.048 101.799 115.182 103.171 115.698 104.418C116.214 105.665 117.088 106.73 118.21 107.48C119.332 108.23 120.651 108.63 122 108.63C123.807 108.63 125.54 107.913 126.819 106.636C128.098 105.359 128.817 103.627 128.82 101.82Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_222_99",
    x: 0,
    y: 0.910156,
    width: 183.465,
    height: 128.286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_99"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_99",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_99",
    x1: 59.34,
    y1: -2.96,
    x2: 112.54,
    y2: 66.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF16BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#DA2AC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#A547D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7E5BE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#6668E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6DEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_99",
    x1: 89.72,
    y1: -26.2798,
    x2: 89.72,
    y2: 149.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#8253D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF16BF",
    stopOpacity: 0.72
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutersImg5);
export default __webpack_public_path__ + "static/media/futers_img5.f5f7fed351fae5937ef7bd1f544f64ae.svg";
export { ForwardRef as ReactComponent };